import * as React from "react";
import { ScreenContext } from '../Core/Util/Screen';
import { Observer } from '../Observer';
export const ScreenSizeObserver = (props) => {
    return React.createElement(ScreenContext.Consumer, null, screen => React.createElement(Observer, { screenSize: screen.size }, props.children));
};
/**
 * Conditionally renders children based on screen size.
 */
export const ScreenSizeConditional = props => {
    return (React.createElement(ScreenSizeObserver, null, (screenSizeProps) => props.condition(screenSizeProps.screenSize) && props.children));
};
